<script lang="ts" setup>
import type { PlpShopTheLook } from '@integration-layer/ampliance/schemas/plp-shop-the-look-schema.localized'
import type { TemplatesPlpShopTheLookProps } from '../Templates/TemplatesPlpShopTheLook.props'
import type { PlpPageProps } from '../Templates/TemplatesPlp.props'

const props = defineProps<{
  deliveryId: string
  locale: string
  vse?: string
  content?: PlpShopTheLook
}>()

const data = await useComponentResponse<PlpShopTheLook>(props)

const message = inject<PlpPageProps>('plpshopthelook')

const mappedData: TemplatesPlpShopTheLookProps = {
  filterName: data.value?.filterName!,
  parentPage: message,
}
</script>

<template>
  <TemplatesPlpShopTheLook v-bind="mappedData" />
</template>
